var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 95,
    viewBox: "0 0 76 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 76,
    height: 11,
    rx: 2,
    fill: "#B7B7B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 32,
    height: 12,
    rx: 2,
    fill: "#B7B7B7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 16,
    height: 2,
    rx: 1,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C0.895431 4 0 4.89543 0 6V7C0 5.89543 0.895431 5 2 5H74C75.1046 5 76 5.89543 76 7V6C76 4.89543 75.1046 4 74 4H2Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 78C5 76.3431 6.34315 75 8 75V75C9.65685 75 11 76.3431 11 78V93C11 94.1046 10.1046 95 9 95H7C5.89543 95 5 94.1046 5 93V78Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 78C65 76.3431 66.3431 75 68 75V75C69.6569 75 71 76.3431 71 78V93C71 94.1046 70.1046 95 69 95H67C65.8954 95 65 94.1046 65 93V78Z",
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15Z",
    fill: "#B7B7B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3955 94H60.3906C64.6517 94 68.1649 90.6601 68.3804 86.4046L71.9958 15H69.0007L65.3853 86.4046C65.1698 90.6601 61.6566 94 57.3955 94Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15H4L7.61542 86.4045C7.83089 90.6601 11.3441 94 15.6052 94H18.6052C14.3441 94 10.8309 90.6601 10.6154 86.4045L7 15Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 15H4L4.35443 22H71.6456L72 15Z",
    fill: "url(#paint0_linear_176_806)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 87.2155C22.7308 85.3458 24.3725 84 26.2792 84H49.7208C51.6275 84 53.2692 85.3458 53.6431 87.2155L55 94H21L22.3569 87.2155Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.478 87.3492C23.783 85.9766 25.0004 85 26.4065 85H49.5935C50.9996 85 52.217 85.9766 52.522 87.3492L54 94H22L23.478 87.3492Z",
    fill: "#B7B7B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C22 0.895432 22.8954 0 24 0H52C53.1046 0 54 0.895432 54 2V4H74C75.1046 4 76 4.89543 76 6V13C76 14.1046 75.1046 15 74 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15H2C0.895432 15 0 14.1046 0 13V6C0 4.89543 0.895432 4 2 4H22V2Z",
    fill: "url(#paint1_linear_176_806)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 50,
    height: 18,
    rx: 4,
    fill: "black",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.508 44.804C20.068 44.668 20.608 44.6 21.128 44.6C21.544 44.6 21.92 44.648 22.256 44.744C22.592 44.84 22.88 44.992 23.12 45.2C23.36 45.408 23.544 45.676 23.672 46.004C23.808 46.332 23.876 46.728 23.876 47.192C23.876 47.768 23.764 48.236 23.54 48.596C23.324 48.948 23.028 49.216 22.652 49.4C22.748 49.56 22.868 49.78 23.012 50.06C23.164 50.332 23.316 50.636 23.468 50.972C23.628 51.3 23.78 51.64 23.924 51.992C24.076 52.344 24.204 52.68 24.308 53H23.228C23.14 52.76 23.028 52.488 22.892 52.184C22.764 51.88 22.628 51.58 22.484 51.284C22.34 50.98 22.196 50.692 22.052 50.42C21.908 50.14 21.78 49.904 21.668 49.712C21.54 49.728 21.408 49.74 21.272 49.748C21.136 49.756 21 49.76 20.864 49.76H20.564V53H19.508V44.804ZM20.564 48.872H21.02C21.572 48.872 21.996 48.748 22.292 48.5C22.588 48.244 22.736 47.808 22.736 47.192C22.736 46.88 22.696 46.62 22.616 46.412C22.544 46.196 22.436 46.028 22.292 45.908C22.156 45.78 21.988 45.688 21.788 45.632C21.596 45.576 21.38 45.548 21.14 45.548C20.932 45.548 20.74 45.56 20.564 45.584V48.872ZM25.6721 53V44.684H29.4041V45.608H26.7521V48.188H29.1521V49.088H26.7521V52.076H29.5961V53H25.6721ZM33.6332 53.18C32.6572 53.18 31.9092 52.816 31.3892 52.088C30.8692 51.36 30.6092 50.236 30.6092 48.716C30.6092 47.94 30.6812 47.284 30.8252 46.748C30.9772 46.212 31.1852 45.776 31.4492 45.44C31.7132 45.104 32.0252 44.864 32.3852 44.72C32.7452 44.568 33.1372 44.492 33.5612 44.492C33.9132 44.492 34.2412 44.54 34.5452 44.636C34.8492 44.724 35.0972 44.836 35.2892 44.972L34.9652 45.872C34.7732 45.744 34.5652 45.64 34.3412 45.56C34.1252 45.48 33.8732 45.44 33.5852 45.44C32.9452 45.44 32.4812 45.708 32.1932 46.244C31.9052 46.772 31.7612 47.596 31.7612 48.716C31.7612 49.844 31.9132 50.712 32.2172 51.32C32.5212 51.928 33.0172 52.232 33.7052 52.232C34.0332 52.232 34.2972 52.192 34.4972 52.112C34.7052 52.032 34.9052 51.928 35.0972 51.8L35.3972 52.652C35.2132 52.796 34.9692 52.92 34.6652 53.024C34.3692 53.128 34.0252 53.18 33.6332 53.18ZM41.1494 44.684C41.0134 45.06 40.8614 45.46 40.6934 45.884C40.5334 46.308 40.3614 46.74 40.1774 47.18C39.9934 47.612 39.8054 48.044 39.6134 48.476C39.4214 48.908 39.2294 49.32 39.0374 49.712V53H37.9574V49.784C37.7654 49.392 37.5694 48.976 37.3694 48.536C37.1694 48.096 36.9774 47.656 36.7934 47.216C36.6094 46.776 36.4334 46.34 36.2654 45.908C36.0974 45.476 35.9454 45.068 35.8094 44.684H36.9734C37.1814 45.316 37.4174 45.984 37.6814 46.688C37.9454 47.392 38.2174 48.048 38.4974 48.656C38.7774 48.048 39.0494 47.392 39.3134 46.688C39.5774 45.984 39.8134 45.316 40.0214 44.684H41.1494ZM44.5668 53.18C43.5908 53.18 42.8428 52.816 42.3228 52.088C41.8028 51.36 41.5428 50.236 41.5428 48.716C41.5428 47.94 41.6148 47.284 41.7588 46.748C41.9108 46.212 42.1188 45.776 42.3828 45.44C42.6468 45.104 42.9588 44.864 43.3188 44.72C43.6788 44.568 44.0708 44.492 44.4948 44.492C44.8468 44.492 45.1748 44.54 45.4788 44.636C45.7828 44.724 46.0308 44.836 46.2228 44.972L45.8988 45.872C45.7068 45.744 45.4988 45.64 45.2748 45.56C45.0588 45.48 44.8068 45.44 44.5188 45.44C43.8788 45.44 43.4148 45.708 43.1268 46.244C42.8388 46.772 42.6948 47.596 42.6948 48.716C42.6948 49.844 42.8468 50.712 43.1508 51.32C43.4548 51.928 43.9508 52.232 44.6388 52.232C44.9668 52.232 45.2308 52.192 45.4308 52.112C45.6388 52.032 45.8388 51.928 46.0308 51.8L46.3308 52.652C46.1468 52.796 45.9028 52.92 45.5988 53.024C45.3028 53.128 44.9588 53.18 44.5668 53.18ZM51.2238 52.076V53H47.5158V44.684H48.5958V52.076H51.2238ZM52.5197 53V44.684H56.2517V45.608H53.5997V48.188H55.9997V49.088H53.5997V52.076H56.4437V53H52.5197Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_806",
    x: 12,
    y: 40,
    width: 52,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_806",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_806",
    x1: 38,
    y1: 15,
    x2: 38,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_806",
    x1: 0,
    y1: 0,
    x2: 76,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.c8c17bfc341524f21bf45bf1799ef69d.svg";
export { ForwardRef as ReactComponent };